import React from "react";
import moment from "moment";
import NoImageIcon from "../../images/no-image-icon.png";
import { Spinner } from "react-bootstrap";

const ReviewPublish = ({
  setStep,
  generalInfo,
  expirationData,
  editId,
  handlePublish,
  loading,
  uniqueError,
  setUniqueError,
}) => {
  const handlePrev = () => {
    setStep(2);
  };

  let getWeek = {
    0: "SUNDAY",
    1: "MONDAY",
    2: "TUESDAY",
    3: "WEDNESDAY",
    4: "THURSDAY",
    5: "FRIDAY",
    6: "SATURDAY",
  };

  return (
    <div className="event-list-cover">
      <div className="title">
        <h3>Review</h3>
        <p>Please review your deal</p>
      </div>
      <div className="review-row">
        <div className="review-col-left">
          {generalInfo.uploadedImg ? (
            <img src={generalInfo.uploadedImg} alt="image" />
          ) : (
            <img src={NoImageIcon} alt="image" />
          )}
        </div>
        <div className="review-col-right">
          {expirationData.date && expirationData.time ? (
            <label>
              EXPIRES ON {getWeek[new Date(expirationData.date).getDay()]},
              {moment(expirationData.date).format("DD MMM")} at{" "}
              {moment(expirationData.time).format("h:mm a")}
            </label>
          ) : (
            ""
          )}
          <h2>{generalInfo.dealName}</h2>
          <p>{generalInfo.desc} </p>
          <div className="ticket-cover">
            <h3>Conditions</h3>
            <p>{generalInfo.condition} </p>
          </div>
        </div>
      </div>
      {uniqueError ? <p style={{ color: "red" }}> {uniqueError} </p> : ""}

      <div className="event-button-row submit">
        <button
          className="back-btn"
          onClick={() => {
            setUniqueError(false);
            handlePrev();
          }}
        >
          Back
        </button>
        <button
          className="next-btn submit-btn"
          onClick={() => {
            setUniqueError(false);
            handlePublish();
          }}
          disabled={loading}
        >
          {loading ? (
            <Spinner
              className="spinner"
              animation="border"
              role="status"
              style={{ height: "20px", width: "20px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : editId ? (
            "Save Changes"
          ) : (
            "Publish"
          )}
        </button>
      </div>
    </div>
  );
};

export default ReviewPublish;
